import React from 'react';
import { Subpage, PageHead, Section } from '../site/Subpage.jsx';
import { useRouteMeta } from '../hooks/useRouteMeta.js';
import { BRAND_OWNER, CONTACT_EMAIL } from '../data/brand.js';
import { TEAM } from '../data/team.js';

export function TeamPage() {
  useRouteMeta('/team');
  return <Subpage>
    <PageHead title="The people behind the studio." actions={false}>
      <p>Keystone AI is owned and operated by the {BRAND_OWNER}. Meet the people leading our product, finances and engineering.</p>
    </PageHead>
    <Section id="team-leadership" title="Our team">
      <ul className="pg-team gl">
        {TEAM.map(person => <li key={person.name}>
          <span className="pg-team-initials" aria-hidden="true">{person.initials}</span>
          <div><h3>{person.name}</h3><p className="pg-team-role">{person.role}</p></div>
          <p>{person.responsibility}</p>
        </li>)}
      </ul>
      <p className="pg-team-contact">Questions about the studio? <a href={`mailto:${CONTACT_EMAIL}`}>Contact our team</a>.</p>
    </Section>
  </Subpage>;
}
